import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  findLegalVersion,
  lazyLegalModules,
  loadLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/terms/*.md"))

export const Route = createFileRoute("/_content/terms/$date")({
  loader: ({ params }) => loadLegalVersion(modules, params.date),
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return seoMeta({
      title: `Terms of Service (${loaderData.dateFormatted})`,
      description: `Archived version of the Entire Terms of Service from ${loaderData.dateFormatted}.`,
      url: `https://entire.com/terms/${loaderData.date}`,
      image: "https://entire.com/og/page/terms.png",
      noindex: true,
    })
  },
  component: TermsVersionPage,
})

function TermsVersionPage() {
  const { asOf, date } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const version = findLegalVersion(versions, date)!
  return <LegalVersionPage basePath="/terms" version={version} versions={versions} />
}
